export default function Signup() {
  return (
    <div>
      <h1>Sign Up</h1>
    </div>
  );
}
